import { SIGNUP } from '@mm/api-routes';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import { trackFacebookEvent } from '../../common/helpers/plugins/facebook-pixel-init';
import { trackSignUpEventGA } from '../../modules/MarketingAnalytics';
import {
  SetNextOnboardingStepType,
  useSetNextOnboardingStep,
} from '../pages/SignupOnboarding/use-set-next-onboarding-step';

export const useRegisterSignupEvent = () => {
  const { setNextOnboardingStep } = useSetNextOnboardingStep();

  const trackSignupEvent = () => {
    trackFacebookEvent(SIGNUP);
    trackSignUpEventGA();
  };
  const registerSignUpEvent = (args?: SetNextOnboardingStepType) => {
    const {
      nextOnboardingStep,
      skipRedirect = false,
      audienceExtractorChannel = undefined,
      options,
    } = args || {};
    const step = nextOnboardingStep || OnboardingSignupStep.NONE;

    setNextOnboardingStep(
      step,
      skipRedirect,
      audienceExtractorChannel,
      options,
    );
  };

  const registerSignUpEventWithTracking = (
    args?: SetNextOnboardingStepType,
  ) => {
    trackSignupEvent();
    registerSignUpEvent(args);
  };

  return {
    trackSignupEvent,
    registerSignUpEvent,
    registerSignUpEventWithTracking,
  };
};
